import { render, staticRenderFns } from "./ListRecords.vue?vue&type=template&id=a9af558a&scoped=true&"
import script from "./ListRecords.vue?vue&type=script&lang=js&"
export * from "./ListRecords.vue?vue&type=script&lang=js&"
import style0 from "./ListRecords.vue?vue&type=style&index=0&id=a9af558a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9af558a",
  null
  
)

export default component.exports